import React from "react";

import { siteLocationPrefix } from "../../constants";
import { TestInput } from "./TestInput";
import * as styles from "./TestStyle.module.css";

export const TestAMSActions = () => (
  <div className={styles.pcAmsActionsWrapper}>
    <h3>Partner Center AMS Actions</h3>
    <div>
      <form
        action={`${siteLocationPrefix}/test/ams/getUserDetailsBySession`}
        method="GET"
        target="_blank"
      >
        Get AMS User Details (auto-detect OID + PC token from session){" "}
        <button className={styles.testButton} type="submit">
          get
        </button>
      </form>
    </div>
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getUserDetailsBySession`}
      label="Get AMS User Details (with token override)"
      buttonText="get"
      actionName="tokenOverride"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setOGCUserOverrideForRoleAdding`}
      label="Set OCG Email to override on role adding process ('delete' to remove)"
      buttonText="set"
      actionName="ogcEmailOverride"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterProgramsBySellerId`}
      label="Get Partner Center Programs by Seller ID"
      buttonText="get"
      actionName="sellerId"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getAllPartnerCenterSellersByEmail`}
      label="Get Partner Center Sellers by Seller Email"
      buttonText="get"
      actionName="email"
    />
    <div>
      <form
        action={`${siteLocationPrefix}/test/ams/getAllPartnerCenterSellersByAadObjectId`}
        method="GET"
        target="_blank"
      >
        Get Partner Center Sellers by AAD Object ID (from session){" "}
        <button className={styles.testButton} type="submit">
          get
        </button>
      </form>
    </div>
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterSellerDetailsBySellerId`}
      label="Get Partner Center Seller Details by Seller ID"
      buttonText="get"
      actionName="sellerId"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterRolesBySelledId`}
      label="Get Partner Center Roles by Seller ID"
      buttonText="get"
      actionName="sellerId"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getAllPartnerCenterAccountsByOwnerEmail`}
      label="Get Partner Center Accounts by Owner Email"
      buttonText="get"
      actionName="email"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getAllPartnerCenterAccountsByStudioName`}
      label="Get Partner Center Accounts by Studio Name"
      buttonText="get"
      actionName="studioName"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterAvailabilityByStudioName`}
      label="Get Partner Center Name Availability by Studio Name"
      buttonText="get"
      actionName="studioName"
    />
    <br />
    <br />
  </div>
);
